import { useEffect } from 'react';

import { useDispatch } from 'react-redux';

import { segmentTrackInitializeAction } from '../segmentRedux';
import useSegmentTrack from './useSegmentTrack';

export default function useSegmentTrackInitializeAction() {
  const dispatch = useDispatch();
  const segmentTrackFunction = useSegmentTrack();

  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') return;
    dispatch(segmentTrackInitializeAction(segmentTrackFunction));
  }, [dispatch, segmentTrackFunction]);
}
